import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, MapPin, X } from "lucide-react";
import { useLang } from "../i18n";

const HIDDEN_ON = ["/admin", "/account", "/login"];

export function DiscountPopup() {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const { t } = useLang();

  useEffect(() => {
    if (HIDDEN_ON.some(p => location.pathname.startsWith(p))) return;
    if (localStorage.getItem("nnm_discount")) return;
    const tm = setTimeout(() => {
      setShow(true);
      localStorage.setItem("nnm_discount", "eligible");
    }, 2500);
    return () => clearTimeout(tm);
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="discount-popup"
          data-testid="discount-popup"
          initial={{ opacity: 0, y: 40, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.96 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <button className="discount-close" onClick={() => setShow(false)} aria-label="Close" data-testid="discount-close-button"><X size={16} /></button>
          <p className="eyebrow">{t("popup.eyebrow")}</p>
          <h3>15% <span>OFF</span></h3>
          <p className="discount-copy">{t("popup.copy")}</p>
          <p className="discount-address" data-testid="discount-address"><MapPin size={14} /> Staneviciaus g. 86B, Vilnius</p>
          <Link to="/contact" className="button button-red full" onClick={() => setShow(false)} data-testid="discount-book-link">{t("popup.cta")} <ArrowUpRight size={15} /></Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
